import { useTranslation } from "react-i18next";
import { getFooterStyles } from "../_publicProfile.styles";
import { Typography } from "@mui/material";

const Footer = () => {
  const { t } = useTranslation("translation", {
    keyPrefix: "public_profile.sections.footer",
  });
  const { cx, classes } = getFooterStyles();

  return (
    <div className={classes.root}>
      <div className={classes.companyInformation}>
        <Typography component="span">
          <a href={t("company_information.name_link")}>
            {t("company_information.name")}
          </a>
        </Typography>
        <span className={classes.separator}>•</span>
        <Typography component="span">
          <a href={t("company_information.address_link")}>
            {t("company_information.address")}
          </a>
        </Typography>
        <span className={classes.separator}>•</span>
        <Typography component="span">
          <a href={t("company_information.phone_number_usa_link")}>
            {t("company_information.phone_number_usa")}
          </a>
        </Typography>
        <span className={classes.separator}>•</span>
        <Typography component="span">
          <a href={t("company_information.phone_number_international_link")}>
            {t("company_information.phone_number_international")}
          </a>
        </Typography>
        <span className={classes.separator}>•</span>

        <Typography component="span">
          <a href={t("company_information.email_us_link")}>
            {t("company_information.email_us")}
          </a>
        </Typography>
      </div>
      <div className={classes.terms}>
        <Typography>
          <a href={t("terms.terms_of_use_link")}>{t("terms.terms_of_use")}</a>
        </Typography>
        <Typography>
          <a href={t("terms.privacy_policy_link")}>
            {t("terms.privacy_policy")}
          </a>
        </Typography>
      </div>
      <div className={cx(classes.copyright, classes.oneLineCopyright)}>
        <Typography>
          {t("copyright")} {t("all_rights_reserved")}
        </Typography>
      </div>

      <div className={cx(classes.copyright, classes.wrappedCopyright)}>
        <Typography>{t("copyright")}</Typography>
        <Typography>{t("all_rights_reserved")}</Typography>
      </div>
    </div>
  );
};

export default Footer;
